import { createFileRoute } from '@tanstack/react-router'

import SubmissionPage from '@/components/pages/backoffice/_klb-petani/_poktan/submission/containers/SubmissionPage'

export const Route = createFileRoute('/_backoffice/klb-petani/poktan/submission/')({
  component: SubmissionPage
})
